'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccorionIcon = exports.Content = exports.Heading = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  cursor: pointer;\n  position: relative;\n'], ['\n  cursor: pointer;\n  position: relative;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  padding: 0;\n  margin-top: 8px;\n  display: ', ';\n'], ['\n  padding: 0;\n  margin-top: 8px;\n  display: ', ';\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 0;\n  right: 0;\n'], ['\n  position: absolute;\n  top: 0;\n  right: 0;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Heading = exports.Heading = _styledComponents2.default.div(_templateObject);

Heading.displayName = 'Heading';
var Content = exports.Content = _styledComponents2.default.div(_templateObject2, function (props) {
  return props.active ? 'block' : 'none';
});

Content.displayName = 'Content';
var AccorionIcon = exports.AccorionIcon = _styledComponents2.default.div(_templateObject3);
AccorionIcon.displayName = 'AccorionIcon';


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-accordion/styles.js
// module id = 2878
// module chunks = 4